/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
import React from "react";
import { classNames } from "@plasmicapp/react-web";

export type Tri7IconProps = React.ComponentProps<"svg"> & {
  title?: string;
};

export function Tri7Icon(props: Tri7IconProps) {
  const { className, style, title, ...restProps } = props;
  return (
    <svg
      xmlns={"http://www.w3.org/2000/svg"}
      fill={"none"}
      viewBox={"0 0 170 171"}
      height={"1em"}
      className={classNames("plasmic-default__svg", className)}
      style={style}
      {...restProps}
    >
      {title && <title>{title}</title>}

      <path
        fill={"currentColor"}
        d={"m53.778 31.049 93.308 54.058-93.146 53.778z"}
        opacity={".15"}
      ></path>

      <path
        fill={"currentColor"}
        d={
          "m147.086 85.107-93.147 53.778-.097-65.347L90.21 52.54v-.385l56.876 32.951z"
        }
        opacity={".15"}
      ></path>

      <path
        fill={"currentColor"}
        d={"M147.086 85.107 53.94 138.884l-.05-33.267 64.127-37.023v-.329z"}
        opacity={".15"}
      ></path>
    </svg>
  );
}

export default Tri7Icon;
/* prettier-ignore-end */
